import axios from "axios";

// Backend API URL from environment variable.
// Exported because <video src> / <img src> need an ABSOLUTE url — they cannot go
// through axios, so monitoring playback builds the url itself.
export const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3070';

// Public axios instance
const axiosPublic = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Private axios instance with JWT interceptor
export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Request interceptor to attach JWT token
axiosPrivate.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle 401 errors
axiosPrivate.interceptors.response.use(
  (response) => {
    console.log(
      "[axiosPrivate] Response received:",
      response.config.url,
      response.status,
    );
    return response;
  },
  async (error) => {
    console.error("[axiosPrivate] Error:", {
      url: error.config?.url,
      status: error?.response?.status,
      message: error?.response?.data?.message || error.message,
    });

    if (error?.response?.status === 401) {
      // Clear auth and redirect to login
      console.log("[axiosPrivate] 401 error, clearing auth and redirecting");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("auth");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default axiosPublic;